<script>
  import { onMount } from 'svelte';
  import clap from '@utils/clap';

  import { getCurrentUserStore } from '@stores/current_user';
  import Avatar from '@components/Avatar.svelte';

  export let group;
  export let mobile;

  let currentUser = getCurrentUserStore('default');
  let selectedObjects = [];

  let isOwnGroup =
    currentUser && group && group.users && group.users.find((user) => user.id === currentUser.id) ? true : false;

  let visible = false;

  let lastScrollTop = 0;

  let start = () => {
    visible = true;
    window.hasShownFloatingLikeOrCommentOnce = true;
    setTimeout(() => (window.willShowFloatingLikeOrComment = false), 3000);
  };

  const checkScrollPosition = () => {
    let scrollTop = window.scrollY;

    if (
      !visible &&
      !window.hasShownFloatingLikeOrCommentOnce &&
      scrollTop > lastScrollTop &&
      scrollTop > 400 &&
      lastScrollTop < 400
    ) {
      setTimeout(start, 500);
    }

    lastScrollTop = scrollTop;
  };

  const setupAnimation = function (node, idx) {
    if (!mobile) {
      setTimeout(() => clap(node, idx), 300);
    } else {
      clap(node);
    }
  };

  onMount(() => {
    if (!isOwnGroup && window.hasShownFloatingLikeOrCommentOnce != true) {
      if (
        group.comments &&
        group.comments.data.length > 0 &&
        ((currentUser && group.comments.data[0].user && group.comments.data[0].user.id !== currentUser.id) || !currentUser)
      ) {
        selectedObjects.push({
          type: 'comment',
          obj: group.comments.data[0],
          user: group.comments.data[0].user,
        });
      } else if (
        group.likes &&
        group.likes.total > 0 &&
        ((currentUser && group.likes.first_like_user.avatar_url !== currentUser.avatar_url) || !currentUser)
      ) {
        for (let i = 0; i < (mobile ? 2 : 3); i++) {
          selectedObjects.push({
            type: 'like',
            user: group.likes.first_like_user,
          });
        }
      }

      if (selectedObjects.length > 0) {
        window.willShowFloatingLikeOrComment = true;
        selectedObjects = selectedObjects;
        window.addEventListener('scroll', checkScrollPosition);
      }
    }

    return () => {
      window.removeEventListener('scroll', checkScrollPosition);
    };
  });
</script>

<style style="text/scss" lang="scss">
  .floating-comment {
    position: absolute;
    top: 0px;
    right: -80px;
    opacity: 0.9;
    z-index: 99;

    padding-left: 12px;
    padding-right: 12px;
    border-radius: 999px;
    background: #333; /* Darker background */
    box-shadow: 0px 4px 14px 0px rgba(255, 255, 255, 0.2); /* Lighter box shadow */
    display: flex;
    align-items: center;
    gap: 12px;
    width: 266px;
    height: 38px;
    animation: floatUpFadeOut 2.5s forwards;
    animation-timing-function: linear;
    box-shadow: 0px 4px 12px 0px #00000021;

    .floating-avatar-text {
      width: 186px;

      .floating-avatar-text-name {
        color: #f1f1f1; /* Lighter text */
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }

      .floating-avatar-text-message {
        color: #e0e0e0; /* Lighter text */
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .floating-like {
    position: absolute;
    top: 4px;
    left: 72px;
    opacity: 0.9;
    zoom: 0.8;
    z-index: 99;
    animation: opacityHide 2s forwards;

    .floating-like-icon {
      position: absolute;
    }

    &.float-desktop {
      animation:
        opacityHide 2s forwards,
        floatDownLeft 0.3s forwards;
      animation-timing-function: linear;
    }
  }

  .floating-like.mobile {
    top: 0px;
    left: 20px;
  }

  .floating-comment.mobile {
    top: 0px;
    left: 65px;
    right: unset;
    animation: floatUpFadeOutMobile 2.5s forwards;
  }

  @keyframes opacityHide {
    0% {
      opacity: 1;
    }
    90% {
      opacity: 0.5;
    }
    100% {
      opacity: 0;
    }
  }

  @keyframes floatDownLeft {
    0% {
      transform: translateY(0) translateX(0);
    }
    20% {
      transform: translateY(7px) translateX(-3px);
    }
    50% {
      transform: translateY(18px) translateX(-12px);
    }
    100% {
      transform: translateY(30px) translateX(-30px);
    }
  }

  @keyframes floatUpFadeOutMobile {
    0% {
      opacity: 0.9;
      transform: translateY(0);
    }
    80% {
      opacity: 0.9;
      transform: translateY(-30px);
    }
    99% {
      z-index: 99;
      transform: translateY(-30px);
    }
    100% {
      opacity: 0;
      z-index: -1;
      transform: translateY(-30px);
    }
  }

  @keyframes floatUpFadeOut {
    0% {
      opacity: 0.9;
      transform: translateY(0);
    }
    50% {
      opacity: 0.9;
      transform: translateY(30px);
    }
    80% {
      opacity: 0.9;
      transform: translateY(30px);
    }
    99% {
      z-index: 99;
      transform: translateY(30px);
    }
    100% {
      opacity: 0;
      z-index: -1;
      transform: translateY(30px);
    }
  }
</style>

{#if visible && selectedObjects.length > 0}
  {#each selectedObjects as obj, idx}
    <div class={`floating-${obj.type} ${!mobile && obj.type == 'like' ? 'float-desktop' : ''}`} class:mobile={mobile}>
      {#if obj.type === 'comment'}
        <div class="floating-avatar">
          <Avatar width={24} src={selectedObjects[0].user.avatar_url} user={selectedObjects[0].user} mobile={mobile} />
        </div>
        <div class="floating-avatar-text">
          <div class="floating-avatar-text-name">{obj.user.name}</div>
          <div class="floating-avatar-text-message">{@html obj.obj.body}</div>
        </div>
      {:else if obj.type === 'like'}
        <div class="floating-like-icon" use:setupAnimation={idx}>
          <svg width="51" height="48" viewBox="0 0 51 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_464_1260)">
              <path
                d="M30.908 12.025C29.6621 12.0277 28.4451 12.4084 27.4111 13.1189C26.3771 13.8294 25.5728 14.8377 25.1 16.0159C24.6267 14.8364 23.8211 13.8272 22.7855 13.1166C21.75 12.406 20.5312 12.0261 19.2839 12.025C15.8153 12.025 13 15.5624 13 19.1163C13 26.8838 23.4867 33.2 25.1 33.2C26.7133 33.2 37.2 26.8838 37.2 19.1163C37.2 15.5624 34.3847 12.025 30.908 12.025Z"
                fill="#FF5567"
                stroke="#FF5567"
                stroke-width="1.65" />
            </g>
            <defs>
              <filter
                id="filter0_d_464_1260"
                x="0.175004"
                y="-2"
                width="49.85"
                height="49.025"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha" />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="6" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_464_1260" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_464_1260" result="shape" />
              </filter>
            </defs>
          </svg>
        </div>
      {/if}
    </div>
  {/each}
{/if}
